import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate, useSearchParams} from "react-router-dom";
import {Alert, Button, Col, Image, message, Row, Spin, Steps} from "antd";
import {
  fetchAddLessonAction, fetchAddLessonProfileAction,
  fetchAddToStudentList, fetchDeleteLessonAction,
  fetchGetInfoAction,
  fetchGetStudentByEducationOrder,
  fetchGroupListAction, fetchOrderCreate, fetchProvincesAction, fetchSetSpecialityStatusAction, fetchSetStatusAction
} from "../../../store/pages/admission/actions";
import {selectStore} from "../../../store/selector";
import {LeftOutlined} from "@ant-design/icons";
import {StyledButton, StyledSettingsContainer} from "./index.styles";

import dayjs from "dayjs";
import {ExecutorStepSix, ExecutorStepTwo, FifthStep} from "../../../components";
import {StyledSteps} from "../../../components/pages/Entrant/EntrantApplication/index.styles";
import {decodeBase64} from "../../../utils/decodeBase64";
import {IconError, WarningIcon} from "../../../assets";
import iconDownload from "../../../assets/icons/page/entrant/admission/icon_download.svg";
const {Step} = Steps

export const EntrantAdmissionWithoutRanking = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {t} = useTranslation(["admissionView", 'executorAdmissionSteps'])

  const [searchParams] = useSearchParams();

  const education_order_id = decodeBase64(searchParams.get("education_order_id"));
  const redirect = searchParams.get("redirect");

  const [currentStep, setCurrentStep] = useState(0)

  //массив для проверки текущего шага
  const [stepsArr, setStepsArr] = useState([])

  const [isCreateOrder, setIsCreateOrder] = useState(false)
  const [locked, setLocked] = useState(false as any)
  const [checkAuthorType, setCheckAuthorType] = useState(false)
  const [currentCollege, setCurrentCollege] = useState({} as any)
  const [addLessonVisible, setAddLessonVisible] = useState(false as any)
  const [checkMarksValue, setCheckMarksValue] = useState(false)

  const [order, setOrder] = useState({
    user_id: null,
    number: null,
    date: dayjs(),
    basis_ru: null,
    basis_kz: null,
    admin_id: null,
    group_id: null,
    sub_admin_id: null,
  })



  //step 2 marks array
  const [arr, setArr] = useState([])

  //step2 добавить предмет
  const [addLessonItem, setAddLessonItem] = useState({
    education_order_id,
    rating: null,
    subject_name: null,
    type: "common",
    author_type: 3
  });


  //step2 добавить профильный предмет
  const [addLessonProfileItem, setAddLessonProfileItem] = useState({
    education_order_id,
    rating_id: null,
    rating: null,
    subject_name: null,
    speciality_id: null,
    qualification_id: null,
    type: "profile",
    author_type: 3
  })


  const {profile: {userProfile: profileData}, admission: {
    groupList,
    addToStudentList,
    getStudentByEducationOrder,
    createOrder,
    getInfo,
    getTotalResult,
    examResult}} = useSelector(selectStore)

  useEffect(() => {
    //@ts-ignore
    dispatch(fetchGetStudentByEducationOrder(education_order_id))
    dispatch(fetchProvincesAction())
    //@ts-ignore
    dispatch(fetchGetInfoAction({education_order_id}))
  }, [])

  useEffect(() => {
    if ((getInfo.data && getInfo.data.educationOrder && getInfo.data.educationOrder.selectedSpecialities) ||
      (getTotalResult.data && getTotalResult.data.educationOrder && getTotalResult.data.educationOrder.selectedSpecialities) ||
      (examResult.data && examResult.data.educationOrder && examResult.data.educationOrder.selectedSpecialities)) {
      let currentCollege = getInfo.data.educationOrder || getTotalResult.data.educationOrder || examResult.data.educationOrder
      let currentCollegeId = getInfo.data.educationOrder.current_college_id || getTotalResult.data.educationOrder.current_college_id || examResult.data.educationOrder.current_college_id


      setCurrentCollege(currentCollege.selectedSpecialities.find((item: any) => item.college_id === currentCollegeId))
    }
  }, [getInfo.data, getTotalResult.data, examResult.data])

  // useEffect(() => {
  //   if(getStudentByEducationOrder.data){
  //     console.log("getStudentByEducationOrder",getStudentByEducationOrder.data)
  //     setOrder((prevState:any) => ({
  //       ...prevState,
  //       user_id: getInfo.data.educationOrder.is_entrant ? getInfo.data.educationOrder.user_id : null
  //     }))
  //   }
  // }, [getStudentByEducationOrder.data])

  useEffect(() => {
    if(createOrder.data){
      setIsCreateOrder(true)

      message.success({ content: `${t('admissionView:orderSuccessCreate')}`, style: {
          marginTop: '50vh'
        } })
    }
  }, [createOrder.data])

  useEffect(() => {
    // user_id
    //@ts-ignore
    dispatch(fetchGetInfoAction({education_order_id: education_order_id}))
  }, [education_order_id])

  useEffect(() => {
    if (getInfo.data) {
      dispatch(fetchGroupListAction(getInfo.data && getInfo.data.educationOrder ? getInfo.data.educationOrder.selectedSpecialities[0].college_id : null))
    }

    if (getInfo.data && getInfo.data.educationOrder) {
      setOrder((prevState: any) => ({
        ...prevState,
        user_id: getInfo.data.educationOrder.is_entrant ? getInfo.data.educationOrder.user_id : null
      }))
    }
  }, [getInfo.data])

  useEffect(() => {
    if(getInfo.data && getInfo.data.educationOrder){
      if(addToStudentList.data && addToStudentList.data.addToStudentList.split(' ')[0] === "success"){
        setCurrentStep(1)

      } else if(addToStudentList.data && addToStudentList.data.addToStudentList.split(' ')[0] !== "success"){
        message.error('Error')
      }
    }
  }, [getInfo.data && getInfo.data.educationOrder.status, addToStudentList.data])

  useEffect(() => {
    if(groupList.data){

      if(!groupList?.data?.reception?.director){
        message.error("В организации не указан директор!")
      }

      setOrder((prevState: any) => ({
        ...prevState,
        sub_admin: groupList.data.reception.teachers[0].fio,
        sub_admin_id: groupList.data.reception.teachers[0].id,
        date: dayjs().format('DD.MM.YYYY'),
        admin_id: groupList?.data?.reception?.director?.id
      }))
    }
  }, [groupList.success])

  const currentStepHandle = (current:any) => {
    if (current < currentStep) {
      // @ts-ignore
      if (stepsArr.indexOf(current) !== -1) {
        setCurrentStep(current)
      }
    }
  }

  const prevStepButton = () => {
    setCurrentStep(currentStep - 1)
  }

  const nextStepButton = (value:any) => {

    if (parseInt(getInfo.data.educationOrder.status) < value) {
      //@ts-ignore
      // dispatch(fetchSetStatusAction({
      //   education_order_id: education_order_id,
      //   status: value
      // }))

      dispatch(fetchSetSpecialityStatusAction({
        id: getInfo.data.educationOrder.selectedSpecialities[0].id,
        status: 32
      }))

      //@ts-ignore
      // dispatch(fetchAddToStudentList({ education_order_id: education_order_id }))

      setCurrentStep(currentStep + 1)
    } else {

      setCurrentStep(currentStep + 1)
    }
  }

  const createOrderHandler = () => {
    if (order.group_id && order.date && order.sub_admin_id && order.number && order.basis_ru && order.basis_kz) {
      // @ts-ignore
      // dispatch(fetchSetStatusAction({
      //   education_order_id,
      //   status: 27
      // }))

      //@ts-ignore
      dispatch(fetchSetSpecialityStatusAction({
        id: getInfo.data.educationOrder.selectedSpecialities[0].id,
        status: 27
      }))
      // @ts-ignore
      dispatch(fetchOrderCreate({...order, selected_speciality_id: getInfo.data.educationOrder.selectedSpecialities[0].id, navigate: navigate}))
    } else {
      message.error(t("alert.stepSix"));
    }
  }

  const goBackToList = () => {
    window.location.replace(`${process.env.REACT_APP_FULLSTACK_URL}${redirect ? redirect : "/"}`)
  }

  const takePdfReceiptHandler = () => {
    window.open(`${process.env.REACT_APP_URL_OLD_REST}${getInfo.data && getInfo.data.educationOrder.receipt_pdf_url}`, "_blank")
  }

  const groupHandler = (value:any, option:any) => {
    setOrder((prevState:any) => ({
      ...prevState,
      group: option.key,
      group_id: parseInt(value),
      group_kk: option.caption_kk
    }))
  }

  const subAdminsHandler = (value:any, option:any) => {
    setOrder((prevState:any) => ({
      ...prevState,
      sub_admin: option.key,
      sub_admin_id: parseInt(value)
    }))
  }

  const dateHandler = (value:any) => {
    setOrder(prevState => ({
      ...prevState,
      date: value
    }))
  }

  const numberHandler = (value:any) => {
    setOrder(prevState => ({
      ...prevState,
      number: value
    }))
  }

  const basisRuHandler = (value:any) => {
    setOrder(prevState => ({
      ...prevState,
      basis_ru: value
    }))
  }

  const basisKzHandler = (value:any) => {
    setOrder(prevState => ({
      ...prevState,
      basis_kz: value
    }))
  }

  const addLessonFooterVisibleHandler = (data: any) => {

    setAddLessonVisible(true)

    let newData = {...addLessonProfileItem}
    newData = {
      ...newData,
      qualification_id: data.qualification_id,
      speciality_id: data.speciality_id,
      type: "profile",
      // @ts-ignore
      profile_id: data.id,
      qualification_name: data.qualification.caption,
      qualification_code: data.qualification.code
    }

    setAddLessonProfileItem(newData)
  }

  //добавить обычнй предмет
  const handleLessonRating = (value: any) => {
    let newData = {...addLessonItem};
    newData = {
      ...newData,
      rating: value,
    }

    setAddLessonItem(newData)
  }

  const handleLessonSubjectName = (value: any) => {
    let newData = {...addLessonItem};
    newData = {
      ...newData,
      subject_name: value,
    }

    setAddLessonItem(newData)
  }

  //добавить профильный предмет
  const handleLessonProfileRating = (value: any) => {
    let newData = {...addLessonProfileItem};
    newData = {
      ...newData,
      rating: value,
    }

    setAddLessonProfileItem(newData)
  }

  const handleLessonProfileSubjectName = (value: any) => {
    let newData = {...addLessonProfileItem};
    newData = {
      ...newData,
      subject_name: value,
    }

    setAddLessonProfileItem(newData)
  }

  //изменить оценку
  const handleEditRating = (value: any, id: any) => {
    // @ts-ignore
    dispatch(fetchEditLessonAction({
      education_order_id,
      rating_id: id,
      rating: value,
    }))
  }

  //удалить оценку
  const handleDeleteRating = (id: any) => {
    dispatch(fetchDeleteLessonAction(id))
  }

  const addLessonHandler = () => {
    // @ts-ignore
    dispatch(fetchAddLessonAction(addLessonItem))

    setAddLessonItem((prevState: any) => ({
      ...prevState,
      rating: null,
      subject_name: null,
    }))
  }

  const addLessonProfileHandler = () => {
    // @ts-ignore
    dispatch(fetchAddLessonProfileAction(addLessonProfileItem))

    setAddLessonProfileItem((prevState: any) => ({
      ...prevState,
      subject_name: null,
      rating: null
    }))

    setAddLessonVisible(false)
  }


  const steps = [
    {
      title: `${t('admissionView:stepsCaptions.stepOne')}`,
      content:
      // это бывший StepOne
        <FifthStep
          educationOrder={getInfo.data && getInfo.data}
        />
    },
    {
      title: `${t('admissionView:stepsCaptions.stepTwo')}`,
      content:
        <ExecutorStepTwo
          addLessonFooterVisibleHandler={addLessonFooterVisibleHandler}
          addLessonVisible={addLessonVisible}

          addLessonItem={addLessonItem}
          addLessonProfileItem={addLessonProfileItem}

          handleLessonRating={handleLessonRating}
          handleLessonSubjectName={handleLessonSubjectName}

          handleLessonProfileRating={handleLessonProfileRating}
          handleLessonProfileSubjectName={handleLessonProfileSubjectName}

          handleEditRating={handleEditRating}
          handleDeleteRating={handleDeleteRating}

          addLessonHandler={addLessonHandler}

          addLessonProfileHandler={addLessonProfileHandler}

          locked={locked}
          setLocked={setLocked}
          setCheckAuthorType={setCheckAuthorType}

          arr={arr}
          setArr={setArr}
          setCheckMarksValue={setCheckMarksValue}

          currentCollege={currentCollege}
        />
    },
    {
      title: `${t('admissionView:stepsCaptions.stepFive')}`,
      content:
        <ExecutorStepSix
          title={t('admissionView:stepsTitle.stepSix.title.enroll')}
          type='admission'
          fio_entrant={getInfo.data && `${getInfo.data.educationOrder.surname_entrant} ${getInfo.data.educationOrder.name_entrant} ${getInfo.data.educationOrder.patronymic_entrant}`}

          order={order}
          groupList={groupList.data}

          subAdminsHandler={subAdminsHandler}
          dateHandler={dateHandler}
          numberHandler={numberHandler}
          groupHandler={groupHandler}
          basisRuHandler={basisRuHandler}
          basisKzHandler={basisKzHandler}
        />
    }
  ]

  const footerButtons = () => {
    switch (currentStep) {
      case 0:
      case 1:
        return (
          <>
            <StyledButton
              className="admission__button admission__button--item"
              onClick={() => goBackToList()}
            >
              <LeftOutlined/>
              {t('admissionView:stepsButton.backToList')}
            </StyledButton>

            {getInfo?.data?.educationOrder?.selectedSpecialities[0]?.status !== "27" ? (
              <StyledButton
                type="primary"
                onClick={() => nextStepButton(24)}
                className="admission__button admission__button--item"
                disabled={getStudentByEducationOrder.failed}
              >
                {t('admissionView:stepsButton.continue')}
              </StyledButton>
            ) : null}
          </>
        )
      case 2:
        return (
          <>
            <StyledButton
              className="admission__button admission__button--item"
              onClick={prevStepButton}
            >
              <LeftOutlined/>
              {t('admissionView:stepsButton.back')}
            </StyledButton>

            <StyledButton
              className="admission__button admission__button--item"
              onClick={() => goBackToList()}
            >
              {t('admissionView:stepsButton.backToList')}
            </StyledButton>


            <StyledButton
              type="primary"
              onClick={() => createOrderHandler()}
              className="admission__button admission__button--item"
              disabled={isCreateOrder}
            >
              {t('admissionView:stepsButton.save')}
            </StyledButton>
          </>
        )
    }
  }

  return(
    <Row justify='center'>
      <Col span={20}>
        <Row>
          <Col span={24} style={{paddingTop: 32, paddingBottom: 32}}>
            <Spin spinning={profileData.loading}>
              <StyledSettingsContainer style={{backgroundColor: "#fff"}}>
                <div className='card'>

                  <Spin spinning={!getInfo.data || getInfo.loading || addToStudentList.loading}>
                    <div className="admission">
                      <Row justify="space-between" align="middle">
                        <Col>
                          <h3 className="admission__title">{t('admissionView:stepsCaptions.application')} №{education_order_id}</h3>
                        </Col>

                        <Col className="admission__button-content">
                          {currentStep === 0 && getInfo?.data?.educationOrder?.receipt_pdf_url ? (
                            <Button
                              className="admission__button col-blue br-blue"
                              onClick={() => takePdfReceiptHandler()}
                            >
                              {t('admissionView:stepsButton.downloadRaspiska')}
                              <Image
                                src={iconDownload}
                                preview={false}
                              />
                            </Button>
                          ) : null}
                        </Col>
                      </Row>
                    </div>


                    <div className="admission" style={{padding: '24px'}}>
                      {getInfo.data && (getInfo?.data?.educationOrder?.status != "0" && getInfo?.data?.educationOrder?.status != "2") ? (
                        <>
                          <Alert
                            className="admission__error"
                            message={getInfo?.data?.educationOrder?.decline_reason ? getInfo?.data?.educationOrder?.decline_reason : "Отказано"}

                            type="error"
                            showIcon
                            icon={<IconError />}
                          />
                        </>
                        ) : (

                        <StyledSteps>
                          <Steps
                            current={currentStep}
                            labelPlacement="vertical"
                            onChange={(current) => currentStepHandle(current)}
                          >
                            {steps.map(item => (
                              <Step key={item.title} title={item.title}/>
                            ))}
                          </Steps>
                        </StyledSteps>
                      )}
                    </div>

                    <div className="admission">

                      {steps[currentStep].content}

                    </div>

                    <Row justify="space-around" className="admission__footer">
                      <Col className="admission__button-content">
                        {getInfo.data && getInfo?.data?.educationOrder?.status == "2" ? footerButtons() : (
                          <StyledButton
                            className="admission__button admission__button--item"
                            onClick={() => goBackToList()}
                          >
                            {t('admissionView:stepsButton.backToList')}
                          </StyledButton>
                        )}

                      </Col>
                    </Row>
                  </Spin>

                </div>
              </StyledSettingsContainer>
            </Spin>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}